import { useEffect, useState } from "react";
import DivStyle from "../../../components/style/div.component";
import CheckTable from "../../../components/table/CheckTable";
import ButtonStyle from "../../../components/style/button.component";
import InputFormStyle from "../../../components/style/input_form.component";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import API from "../../../api/api";
import { ICafe } from "../../cafe/interface/interface";
interface AttendeeProps {
  setPubId: (value: any) => void;
  setPubName: (value: any) => void;
  setIsOpen: (value: any) => void;
}

const SearchFranchisePub = (props: AttendeeProps) => {
  const [selected, setSelected] = useState("");
  const [dataList, setDataList] = useState<any[]>([]);
  const { setPubId, setPubName, setIsOpen } = props;
  const [search, setSearch] = useState("");
  const headers = [
    {
      text: "id",
      align: "center",
      value: "id",
      sortable: false,
    },
    {
      text: "펍 이름",
      align: "center",
      value: "pubName",
      sortable: false,
    },
  ];

  const getList = async () => {
    const res = await API.getCafes(1, "FRANCHISE", search, 100);
    if (res && res.status === 200) {
      // Promise.all을 사용하여 모든 비동기 작업 완료를 기다림
      setDataList(res.data.pubDetailResponseList);
    }
  };

  useEffect(() => {
    getList();
  }, [search]);

  const setData = async () => {
    if (dataList.length > 0 && selected !== "") {
      const data = dataList[parseInt(selected)];

      setPubId(data["id"]);
      setPubName(data["pubName"]);
      setIsOpen(false);
    } else {
      alert("선택해주세요.");
    }
  };

  return (
    <DivStyle
      style={{
        maxWidth: "500px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        minWidth: "300px",
      }}
      borderRadius="10px"
      position="fixed"
      width="90%"
      height="auto"
      backgroundColor="black"
      color="white"
      display="flex"
      flex_direction="column"
      align_items="center"
    >
      <h4>가맹펍 검색</h4>
      <DivStyle
        width="80%"
        display="flex"
        flex_direction="row"
        align_items="center"
      >
        <InputFormStyle
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        ></InputFormStyle>
        <div>
          <Icon path={mdiMagnify} size={1} />
        </div>
      </DivStyle>
      <CheckTable
        selected={selected}
        setSelected={setSelected}
        headers={headers}
        dataList={dataList}
      />
      <DivStyle
        display="flex"
        flex_direction="row"
        width="auto"
        marginTop="30px"
        marginBottom="30px"
      >
        <ButtonStyle
          color="white"
          border="none"
          borderRadius="5px"
          width="100px"
          height="40px"
          marginRight="5px"
          backgroundColor="#1976D2"
          onClick={() => setData()}
        >
          적용
        </ButtonStyle>
        <ButtonStyle
          color="white"
          backgroundColor="#757575"
          border="none"
          borderRadius="5px"
          width="100px"
          height="40px"
          marginLeft="5px"
          onClick={() => setIsOpen(false)}
        >
          닫기
        </ButtonStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default SearchFranchisePub;
